// helper function to create and return a proper typeform link with the user param in it

interface ContactUsLinkParams {
  firstName: string;
  lastName: string;
  email: string;
  country: string;
  orgType: string;
  schoolName?: string;
  orgName?: string;
  role: string;
  source?: string;
  seats: string;
  years: string;
  medium: 'contactus_text' | null;
  zipCode: string;
}

function genTypeformLink({
  firstName,
  lastName,
  email,
  country,
  orgType,
  schoolName,
  orgName,
  role,
  source = 'in_app',
  medium,
  seats,
  years,
  zipCode,
}: ContactUsLinkParams) {
  const url = new URL('https://showbie.typeform.com/soccontact');
  const hashParams = new URLSearchParams(
    Object.entries({
      firstName,
      lastName,
      email,
      country,
      orgType,
      orgName: schoolName || orgName,
      role,
      source,
      seats,
      zip: zipCode,
      medium,
      campaign: null,
      term: years,
    }).map(([key, value]) => [key.toLowerCase(), value ?? 'xxxxx'])
  );
  url.hash = hashParams.toString();
  return url.toString();
}

export default genTypeformLink;
